import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * Title of the section. FormattedMessage id
   */
  title: PropTypes.string,
  /**
   * Section content
   */
  children: PropTypes.node,
  /**
   * If true, show horizontal rule at the end
   */
  showSeparatorLine: PropTypes.bool,
  /**
   * Optional content rendered on the right side of the section header.
   */
  headerAction: PropTypes.node,
  /**
   * Class to override header margin bottom styles
   */
  headerMarginClass: PropTypes.string,
}

/**
 * Container with title, padded content and a horizontal rule in the end
 */
function Section(props) {
  const {
    children = null,
    title = null,
    showSeparatorLine = true,
    headerAction = null,
    headerMarginClass = 'mb-4',
  } = props ?? {}

  return (
    <>
      {title && (
        <div className={clsx('d-flex justify-content-between align-items-center', headerMarginClass)}>
          <div className="text-strong">
            <FormattedMessage id={title} />
          </div>
          {headerAction}
        </div>
      )}
      <div className="ms-3 me-3">{children}</div>
      {showSeparatorLine && <hr className="mb-4" />}
    </>
  )
}

Section.propTypes = propTypes

export default Section
